import { render, staticRenderFns } from "./dydp_manage_novel.vue?vue&type=template&id=1c3b802b&scoped=true"
import script from "./dydp_manage_novel.vue?vue&type=script&lang=js"
export * from "./dydp_manage_novel.vue?vue&type=script&lang=js"
import style0 from "./dydp_manage_novel.vue?vue&type=style&index=0&id=1c3b802b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3b802b",
  null
  
)

export default component.exports